import React from 'react';
import styles from './TextArea.module.scss';
export const TextArea = ({ ref, ...props })=>/*#__PURE__*/ React.createElement("textarea", {
        ref: ref,
        className: styles.textArea,
        ...props
    });
